import { useMemo } from 'react';
import { AnyNetworkElement } from '../types/network';
import { useNetworkElementsStore } from '../store/networkElementsStore';

export function useNetworkElement<T extends AnyNetworkElement>(elementId: string): T | undefined {
  // Create a memoized selector that will only update when the specific element changes
  const selector = useMemo(
    () => (state: ReturnType<typeof useNetworkElementsStore.getState>) => 
      state.elements.find(el => el.id === elementId) as T | undefined,
    [elementId]
  );

  // Use the selector to subscribe to changes for this specific element
  return useNetworkElementsStore(selector);
}